import { useState } from 'react';
import { Link } from 'react-router-dom';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../../artist-help/profile/styles.css';

export default function ProfileGalleryHelpSellAndShipPage() {
  const t = useTranslations('galleries_help.sell_and_ship');
  const [openSections, setOpenSections] = useState({
    whoCanSell: false,
    buyNow: false,
    sellInStore: false,
    cancellationPolicy: false,
    modifyingPrices: false,
    shippingGuidelines: false,
    taxResponsibilities: false,
    returnsRefunds: false,
    collectorsDisplayReviews: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category gallery-help-category">
      <header className="artist-help-category__header gallery-help-category__header">
        <GoBackButton alternativeRoute="/profile/gallery-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body gallery-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('whoCanSell')}
            aria-expanded={openSections.whoCanSell}
          >
            <h2>{t('sections.who_can_sell.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.whoCanSell ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.whoCanSell && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.who_can_sell.p1')}</p>
              <p>{t('sections.who_can_sell.p2')}</p>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.who_can_sell.work_of_artist.title')}</h3>
                <p>{t('sections.who_can_sell.work_of_artist.p1')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.who_can_sell.gallery_owned.title')}</h3>
                <p>{t('sections.who_can_sell.gallery_owned.p1')}</p>
                <p>{t('sections.who_can_sell.gallery_owned.p2')}</p>
                <p>{t('sections.who_can_sell.gallery_owned.p3')}</p>
              </div>

              <p>{t('sections.who_can_sell.p3')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('sellInStore')}
            aria-expanded={openSections.sellInStore}
          >
            <h2>{t('sections.sell_in_store.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.sellInStore ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.sellInStore && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.sell_in_store.p1')}</p>
              <p>{t('sections.sell_in_store.p2')}</p>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.sell_in_store.commission_volume.title')}</h3>
                <p>{t('sections.sell_in_store.commission_volume.p1')}</p>
                <p>{t('sections.sell_in_store.commission_volume.p2')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.sell_in_store.how_it_works.title')}</h3>
                <ul>
                  <li>{t('sections.sell_in_store.how_it_works.list_1')}</li>
                  <li>{t('sections.sell_in_store.how_it_works.list_2')}</li>
                  <li>{t('sections.sell_in_store.how_it_works.list_3')}</li>
                </ul>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.sell_in_store.add_previously_sold.title')}</h3>
                <p>{t('sections.sell_in_store.add_previously_sold.p1')}</p>
                <ul>
                  <li>{t('sections.sell_in_store.add_previously_sold.list_1')}</li>
                </ul>
                <p>{t('sections.sell_in_store.add_previously_sold.p2')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.sell_in_store.discounts_price_changes.title')}</h3>
                <p>{t('sections.sell_in_store.discounts_price_changes.p1')}</p>
              </div>

              <p>
                {t('sections.sell_in_store.p3_pre')}{' '}
                <Link
                  to="/sell-in-store-terms"
                  state={{ fromGalleryHelpSellAndShip: true }}
                >
                  {t('sections.sell_in_store.link_label')}
                </Link>.
                {t('sections.sell_in_store.p3_post')}
              </p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('buyNow')}
            aria-expanded={openSections.buyNow}
          >
            <h2>{t('sections.buy_now.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.buyNow ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.buyNow && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.buy_now.p1')}</p>
              <p>{t('sections.buy_now.p2')}</p>
              <p>{t('sections.buy_now.p3')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('cancellationPolicy')}
            aria-expanded={openSections.cancellationPolicy}
          >
            <h2>{t('sections.cancellation_policy.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.cancellationPolicy ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.cancellationPolicy && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.cancellation_policy.p1')}</p>
              <p>{t('sections.cancellation_policy.p2')}</p>
              <p>{t('sections.cancellation_policy.p3')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('modifyingPrices')}
            aria-expanded={openSections.modifyingPrices}
          >
            <h2>{t('sections.modifying_prices.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.modifyingPrices ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.modifyingPrices && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.modifying_prices.p1')}</p>
              <p>{t('sections.modifying_prices.p2')}</p>
              <p>{t('sections.modifying_prices.p3')}</p>
              <p>{t('sections.modifying_prices.p4')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('shippingGuidelines')}
            aria-expanded={openSections.shippingGuidelines}
          >
            <h2>{t('sections.shipping_guidelines.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.shippingGuidelines ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.shippingGuidelines && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.shipping_guidelines.intro')}</p>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.shipping_guidelines.step_1.title')}</h3>
                <p>{t('sections.shipping_guidelines.step_1.intro')}</p>
                <ul>
                  <li>{t('sections.shipping_guidelines.step_1.list_1')}</li>
                  <li>{t('sections.shipping_guidelines.step_1.list_2')}</li>
                </ul>
                <p>{t('sections.shipping_guidelines.step_1.p1')}</p>
                <p>{t('sections.shipping_guidelines.step_1.p2')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.shipping_guidelines.step_2.title')}</h3>
                <p>{t('sections.shipping_guidelines.step_2.p1')}</p>
                <p>{t('sections.shipping_guidelines.step_2.intro')}</p>
                <ul>
                  <li>{t('sections.shipping_guidelines.step_2.list_1')}</li>
                  <li>{t('sections.shipping_guidelines.step_2.list_2')}</li>
                </ul>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.shipping_guidelines.step_3.title')}</h3>
                <p>{t('sections.shipping_guidelines.step_3.p1')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.shipping_guidelines.step_4.title')}</h3>
                <p>{t('sections.shipping_guidelines.step_4.p1')}</p>
                <p>{t('sections.shipping_guidelines.step_4.p2')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('taxResponsibilities')}
            aria-expanded={openSections.taxResponsibilities}
          >
            <h2>{t('sections.tax_responsibilities.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.taxResponsibilities ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.taxResponsibilities && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.tax_responsibilities.intro')}</p>
              <ul>
                <li>{t('sections.tax_responsibilities.list_1')}</li>
                <li>{t('sections.tax_responsibilities.list_2')}</li>
                <li>{t('sections.tax_responsibilities.list_3')}</li>
              </ul>
              <div className="artist-help-category__note">
                <h3>{t('sections.tax_responsibilities.note_title')}</h3>
                <p>{t('sections.tax_responsibilities.note_body')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('returnsRefunds')}
            aria-expanded={openSections.returnsRefunds}
          >
            <h2>{t('sections.returns_refunds.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.returnsRefunds ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.returnsRefunds && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.returns_refunds.p1')}</p>
              <p>{t('sections.returns_refunds.p2')}</p>
              <p>{t('sections.returns_refunds.p3')}</p>
              <p>
                {t('sections.returns_refunds.p4_pre')}{' '}
                <Link to="/return-and-refund-policy" state={{ fromPath: '/profile/gallery-help/sell-and-ship' }}>
                  {t('sections.returns_refunds.link_1_label')}
                </Link>
                {t('sections.returns_refunds.p4_middle')}{' '}
                <Link
                  to="/limited-editions-return-and-refund-policy"
                  state={{ fromPath: '/profile/gallery-help/sell-and-ship' }}
                >
                  {t('sections.returns_refunds.link_2_label')}
                </Link>
                {t('sections.returns_refunds.p4_post')}
              </p>
              <p>
                {t('sections.returns_refunds.p5_pre')} <a href="mailto:galleries@suarte.art">{t('sections.returns_refunds.email')}</a>{t('sections.returns_refunds.p5_post')}
              </p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('collectorsDisplayReviews')}
            aria-expanded={openSections.collectorsDisplayReviews}
          >
            <h2>{t('sections.collectors_display_reviews.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.collectorsDisplayReviews ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.collectorsDisplayReviews && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.collectors_display_reviews.p1')}</p>
              <p>{t('sections.collectors_display_reviews.p2')}</p>
              <p>{t('sections.collectors_display_reviews.p3')}</p>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
